/**
 * Generated runtime TestId mirror for frontend/src/pages/ExecutionDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ExecutionDetailTestIds = {
  badgeSseConnection: "badge-sse-connection",
  btnCancelExecution: "btn-cancel-execution",
  cardExecutionInfo: "card-execution-info",
  cardTitleExecutionError: "card-title-execution-error",
  executionDetailTitle: "execution-detail-title",
  executionErrorMessage: "execution-error-message",
  linkJobDetail: "link-job-detail",
  sectionExecutionStatistics: "section-execution-statistics",
  sectionTaskExecutions: "section-task-executions",
  btnViewLogs: (task_taskInstanceKey: string) => `btn-view-logs-${task_taskInstanceKey}`,
  btnViewLogsPrefix: () => "btn-view-logs-" as TestIdPrefix,
  taskRow: (task_taskInstanceKey: string) => `task-row-${task_taskInstanceKey}`,
  taskRowPrefix: () => "task-row-" as TestIdPrefix
} as const;
